angular.module("gestioneLegami.components", []).component("gestioneLegami", {
    templateUrl: "ng/components/gestioneLegami/gestioneLegami.html",
    bindings: {
      dealerCustomer: "<",
    },
    controller: gestioneLegamiController,
    controllerAs: "gestLegamiCtrl",
  });
  
  function gestioneLegamiController(
    $modalService,
    $searchUserService,
    $rootScope
  ) {
    var self = this;
  
    self.$onInit = function () {
      self.ndgSubordinante = null;
      self.ndgSubordinato = null;
      self.legame = {
        ndgSubordinante: null,
        ndgSubordinato: null,
        selected: false,
      };
      self.isDeletingLegame = false;
      self.isLoadingSearch = false;
      self.isAddingLegame = false;
      self.editLegameMode = false;
      self.handleChangeAddModal();
    };
  
    self.handleChangeGestioneLegami = function (value, property) {
      self[property] = value;
    };
  
    self.handleChangeAddModal = function (value, property) {
      if (self.legame && self.legame[property]) {
        self.legame[property] = value;
      }
    };
  
    self.searchNdg = function (subordinante, subordinato) {
      self.legami = [];
      self.isLoadingSearch = true;
      $searchUserService
        .gestioneLegamiUtenza(subordinante, subordinato)
        .then(function (response) {
          if (response.success) {
            self.legami = response.gestioneLegamiUtenzaList;
            console.log("legami: ", response);
          }
          self.isLoadingSearch = false;
        })
        .catch(function (error) {
          console.log("ERROR", error);
          self.isLoadingSearch = false;
        });
    };
  
    self.openModalDelete = function (legame) {
      self.ndgSubordinante = legame.ndgSubordinante;
      self.ndgSubordinato = legame.ndgSubordinato;
      self.idLegame = legame.id;
      $modalService.openModal("modaleDelete");
    };
  
    self.closeModalDelete = function () {
      $modalService.closeModal("modaleDelete");
    };
  
    self.deleteLegame = function () {
      self.isDeletingLegame = true;
      $searchUserService
        .eliminaLegame( self.idLegame, self.ndgSubordinante, self.ndgSubordinato)
        .then(function (response) {
          if (response.success) {
            console.log("deleting legame successful: ", response);
            $modalService.closeModal("modaleDelete");
            self.legami = self.legami.filter(function (x) {
              return (
                x.ndgSubordinante != self.ndgSubordinante &&
                x.ndgSubordinato != self.ndgSubordinato
              );
            });
          } else {
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_GENERIC",
            });
          }
          self.isDeletingLegame = false;
        })
        .catch(function (error) {
          console.log("ERROR", error);
          self.isDeletingLegame = false;
        });
    };
  
    self.openModalAdd = function (editLegameMode) {
      $modalService.openModal("modaleAdd");
      self.legame.selected = false;
      if (!editLegameMode) {
        self.legame.ndgSubordinante = null;
        self.legame.ndgSubordinato = null;
      }
    };
  
    self.addLegame = function () {
      self.isAddingLegame = true;
      $searchUserService
        .inserisciLegame(
          self.legame.ndgSubordinante,
          self.legame.ndgSubordinato,
          self.legame.selected
        )
        .then(function (response) {
          if (response.success) {
            console.log("adding legame successful: ", response);
            self.closeModalAdd(self.editLegameMode);
            self.searchNdg(
              self.legame.ndgSubordinante,
              self.legame.ndgSubordinato
            );
            $rootScope.$broadcast("addAlert", {
              text: "REQUEST_PV_SUBMITTED",
            });
          }
          self.isAddingLegame = false;
        })
        .catch(function (error) {
          console.log("ERROR", error);
          self.isAddingLegame = false;
        });
    };
  
    self.editLegame = function (legame, index) {
      self.editLegameMode = true;
      self.openModalAdd(self.editLegameMode);
      self.legame.ndgSubordinante = legame.ndgSubordinante;
      self.legame.ndgSubordinato = legame.ndgSubordinato;
      self.idLegame = legame.id;
      self.legame.selected = legame.subordinatoPlus;
    };
  
    self.updateLegame = function () {
      self.isUpdatingLegame = true;
      $searchUserService
        .updateLegame(
          self.idLegame,
          self.legame.ndgSubordinante,
          self.legame.ndgSubordinato,
          self.legame.selected
        )
        .then(function (response) {
          if (response.success) {
            console.log("updating legame successful: ", response);
            self.closeModalAdd(self.editLegameMode);
            $rootScope.$broadcast("addAlert", {
              text: "REQUEST_PV_SUBMITTED",
            });
            self.searchNdg(
              self.legame.ndgSubordinante,
              self.legame.ndgSubordinato
            );
            self.ndgSubordinante = self.legame.ndgSubordinante;
            self.ndgSubordinato = self.legame.ndgSubordinato;
          }
          self.isUpdatingLegame = false;
        })
        .catch(function (error) {
          console.log("ERROR", error);
          self.isUpdatingLegame = false;
        });
    };
  
    self.closeModalAdd = function (editLegameMode) {
      $modalService.closeModal("modaleAdd");
      if (!editLegameMode) {
        self.ndgSubordinante = null;
        self.ndgSubordinato = null;
      }
      self.editLegameMode = false;
    };
  
    self.check = function (el) {
      el.selected = !el.selected;
    };
  
    self.checkFields = function () {
      return self.legame.ndgSubordinante && self.legame.ndgSubordinato;
    };
  }
  